<template>
  <div
    class="player-container"
    :style="
      video == '' ? `background-image:url(` + urlImage + `);height:270px` : ''
    "
  >
    <vue-core-video-player
      v-if="video"
      ref="video"
      @loadedmetadata="loaded"
      @play="playFunc"
      @pause="pauseFunc"
      @timeupdate="timeupdate"
      @seeked="seeked"
      @ended="ended"
      :autoplay="false"
      :src="urlVideo"
      :cover="urlImage"
    ></vue-core-video-player>
  </div>
</template>

<script>
import { HTTP } from "@/service/axios.js";

export default {
  props: {
    id: {
      type: String,
      default() {
        return "";
      },
    },
    topic: {
      type: Object,
      default() {
        return null;
      },
    },
    video: {
      type: String,
      default() {
        return "";
      },
    },
    image: {
      type: String,
      default() {
        return "";
      },
    },
    takes: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    urlImage() {
      if (this.image != "") {
        return `${this.urlCouse}${this.id}/${this.image}`;
      } else {
        return "https://1080motion.com/wp-content/uploads/2018/06/NoImageFound.jpg.png";
      }
    },
    urlVideo() {
      return `${this.urlCouse}${this.id}/${this.video}`;
    },
    token() {
      return this.$store.state.token;
    },
  },
  data() {
    return {
      urlCouse: process.env.VUE_APP_BASE_URL_FILE_COURSE,
      startTime: null,
      latestTime: 0,
      watchedEeveryTime: [
        { start: null, end: null },
        // { start: 0, end: 20 },
        // { start: 10, end: 15 },
        // { start: 30, end: 40 },
        // { start: 25, end: 35 },
        // { start: 60, end: 100 },
        // { start: 50, end: 100 },
      ],
      playTime: [],
      allowAddWatched: true,
      duration: 0,
    };
  },
  mounted() {
    setTimeout(() => {
      this.setTopic();
    }, 500);

    window.addEventListener(
      "beforeunload",
      () => {
        let index = this.watchedEeveryTime.length - 1;

        this.watchedEeveryTime[index].end =
          this.playTime[this.playTime.length - 1];
        this.latestTime = this.watchedEeveryTime[index].end;
        this.saveTrackVideo(false);
      },
      false
    );
  },
  beforeDestroy() {
    let index = this.watchedEeveryTime.length - 1;

    this.watchedEeveryTime[index].end = this.playTime[this.playTime.length - 1];
    this.latestTime = this.watchedEeveryTime[index].end;
    this.saveTrackVideo(false);
  },
  methods: {
    setTopic() {
      if (this.topic && this.topic.watched.length > 0) {
        this.watchedEeveryTime = [];
        for (let index = 0; index < this.topic.watched.length; index++) {
          this.watchedEeveryTime.push({
            start: this.topic.watched[index].min,
            end: this.topic.watched[index].max,
          });
        }

        this.watchedEeveryTime.push({ start: null, end: null });

        this.startTime =
          this.topic.latestTime >= this.duration ? null : this.topic.latestTime;
      }
    },
    loaded(v) {
      this.duration = v.target.duration;

      this.$emit("setAllTimeVideo", v.target.duration);
      let index = this.watchedEeveryTime.length - 1;

      this.watchedEeveryTime[index].start = 0;
      // if (this.startTime) {
      //   this.watchedEeveryTime[index].start = this.startTime;
      // } else {
      //   this.watchedEeveryTime[index].start = 0;
      // }
    },
    playFunc(v) {
      // if (this.startTime) {
      //   v.target.currentTime = this.startTime;
      //   this.startTime = null;
      // }

      let index = this.watchedEeveryTime.length - 1;
      this.watchedEeveryTime[index].start = v.target.currentTime;
    },
    async pauseFunc(v) {
      this.latestTime = v.target.currentTime;
      let index = this.watchedEeveryTime.length - 1;

      this.watchedEeveryTime[index].end = v.target.currentTime;

      this.watchedEeveryTime.push({ start: null, end: null });

      this.saveTrackVideo(false);
    },
    timeupdate(v) {
      this.playTime.push(v.target.currentTime);
    },
    async seeked(v) {
      if (
        this.watchedEeveryTime[this.watchedEeveryTime.length - 1].start !=
          null &&
        this.watchedEeveryTime[this.watchedEeveryTime.length - 1].end == null
      ) {
        this.watchedEeveryTime[this.watchedEeveryTime.length - 1].end =
          this.playTime[this.playTime.length - 2];
        this.playTime = [];
      }

      this.watchedEeveryTime.push({ start: null, end: null });

      let index = this.watchedEeveryTime.length - 1;
      this.watchedEeveryTime[index].start = v.target.currentTime;
    },
    ended(v) {
      this.latestTime = v.target.currentTime;
      this.saveTrackVideo(true);
    },
    getWatched(times) {
      let group = [];

      let min = [];
      let max = [];
      times.map((item, index) => {
        times.map((item2) => {
          if (
            (item.start >= item2.start && item.start <= item2.end) ||
            (item.end >= item2.start && item.end <= item2.end)
          ) {
            if (item.start != null && item.end != null) {
              min.push(item2.start);
              max.push(item2.end);
            }
          }
        });

        let mn = Math.min(...min);
        let mx = Math.max(...max);

        let filter = group.filter(
          (filter) => filter.min == mn && filter.max == mx
        );

        if (filter.length == 0 && min.length > 0 && max.length > 0) {
          group.push({ min: mn, max: mx });
        }
        min = [];
        max = [];
      });

      return group;
    },
    getAlltime() {
      let group = this.getWatched(this.watchedEeveryTime);

      let total = 0;

      group.map((item) => {
        let sum = item.max - item.min;
        total += sum;
      });

      return total;
    },
    getPercentGrowth(num) {
      let ratePercent = this.allTimeVideo / 100;
      let percent = num / ratePercent;
      if (isFinite(percent) === true) {
        return Number(percent.toFixed(2));
      } else {
        return 0;
      }
    },
    saveTrackVideo(nextTo) {
      let watched = this.getWatched(this.watchedEeveryTime);
      let timeAll = this.getAlltime();

      this.$emit("saveTrackVideo", nextTo, watched, timeAll, this.latestTime);
    },
  },
};
</script>

<style scoped>
.player-container {
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  border-radius: 10px;
}
</style>